var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33024 0.61472C5.61589 0.25205 4.95649 0.0652195 4.33006 0.0652195C3.46185 0.0652195 2.73651 0.33997 2.15404 0.90046C1.60454 1.41699 1.24187 2.10936 1.06603 2.99955H0.50554L0.16485 3.79083H0.96712C0.95613 3.8238 0.95613 3.88974 0.95613 3.96667V4.25241H0.51653L0.17584 5.04369H1.02207C1.17593 5.99982 1.50563 6.74714 2.02216 7.28565C2.58265 7.8901 3.31898 8.18683 4.25313 8.18683C4.87956 8.18683 5.45104 8.04396 5.94559 7.74723L5.95658 6.08774C5.37411 6.54932 4.80263 6.78011 4.26412 6.78011C3.41789 6.78011 2.86839 6.19764 2.6376 5.04369H4.54986L4.89055 4.25241H2.54968L2.56067 3.79083H5.02243L5.36312 2.99955H2.68156C2.93433 1.99946 3.45086 1.49392 4.22016 1.49392C4.65976 1.49392 5.14332 1.65877 5.65985 1.98847L6.33024 0.61472Z",
    fill: "#192923"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuro);
export default __webpack_public_path__ + "static/media/icon_euro.c682d94ea4b38a7e15f1a0124b9692c4.svg";
export { ForwardRef as ReactComponent };